// extracted by mini-css-extract-plugin
module.exports = {"drawArrow":"styles_drawArrow__IgkLe","draw":"styles_draw__o3GQF"};